module.exports = {"id":"171097","name":"Marco Motta","rating":"73","photo":"./data/images/photos/2/171097.png","club":{"name":"UD Almería","logo":"./data/images/clubs/UDAlmeria.png"},"positions":["DD","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcoMotta0.json
// module id = 2741
// module chunks = 0